import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { categoryLabels } from './constants';

export function DuesAllAccounts({ accounts, allPayments, onAddAccount, onRecordPayment }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-bold text-gray-800">All Member Accounts</h3>
        <button onClick={onAddAccount} className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 flex items-center space-x-2" data-testid="add-dues-account-btn">
          <FaPlus /> <span>Add Account</span>
        </button>
      </div>

      {accounts.length > 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Member</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Charged</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Paid</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Due</th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {accounts.map(account => {
                const amountDue = account.balance < 0 ? Math.abs(account.balance) : 0;
                const hasCredit = account.balance > 0;
                return (
                  <tr key={account.account_id}>
                    <td className="px-4 py-4">
                      <p className="font-medium text-gray-800">{account.member_name}</p>
                      {account.is_proxy && <span className="text-xs text-gray-500">(Proxy)</span>}
                    </td>
                    <td className="px-4 py-4 text-gray-600">{categoryLabels[account.category]}</td>
                    <td className="px-4 py-4 text-right text-gray-600">${account.total_owed.toFixed(2)}</td>
                    <td className="px-4 py-4 text-right text-green-600">${account.total_paid.toFixed(2)}</td>
                    <td className="px-4 py-4 text-right">
                      {amountDue > 0 ? (
                        <span className="font-bold text-red-600">${amountDue.toFixed(2)}</span>
                      ) : hasCredit ? (
                        <span className="font-bold text-green-600">$0.00 <span className="text-xs">(+${account.balance.toFixed(2)} credit)</span></span>
                      ) : (
                        <span className="font-bold text-green-600">$0.00</span>
                      )}
                    </td>
                    <td className="px-4 py-4 text-center">
                      <button
                        onClick={() => onRecordPayment(account)}
                        className="px-3 py-1.5 bg-green-600 text-white text-sm rounded hover:bg-green-700"
                        data-testid={`record-payment-${account.account_id}`}
                      >
                        Record Payment
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <p className="text-gray-500">No dues accounts created yet. Add member accounts to start tracking dues.</p>
        </div>
      )}

      {/* All Payments */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">All Payments</h3>
        {allPayments.length > 0 ? (
          <div className="space-y-3 max-h-96 overflow-y-auto">
            {allPayments.map(payment => (
              <div key={payment.payment_id} className="flex justify-between items-center border-b pb-3">
                <div>
                  <p className="font-medium text-gray-800">{payment.member_name}</p>
                  <p className="text-sm text-gray-500">Receipt: {payment.receipt_number}</p>
                  <p className="text-sm text-gray-500">{new Date(payment.payment_date).toLocaleDateString()} - {payment.billing_period}</p>
                </div>
                <p className="text-lg font-bold text-green-600">+${payment.amount.toFixed(2)}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-4">No payments recorded yet</p>
        )}
      </div>
    </div>
  );
}
